<template>
    <ion-page style="overflow: auto;">
        <div>
            <fis-header></fis-header>
            <div class="container-fluid" id="top-div">
                <div class="row">
                    <div class="col-sm-1"></div>
                    <home-search v-if="countries.length > 0" v-bind:countries="countries"></home-search>
                    <div class="col-sm-1"></div>
                    <sponsors-page style="margin-top: -15px;"></sponsors-page>
                    <div class="col-sm-1"></div>
                </div>
            </div>


            <div class="container-fluid" id="mid-div">
                <!-- First mid content -->
                <div class="row">
                    <div class="col-sm-1"></div>

                    <div class="col-sm-10">
                        <div class="row" id="global">
                            <div class="col-sm-8" id="global-text">
                                <h2> FINDIT SMART GLOBAL JOURNEY </h2>

                                    <p>Keep it Simple Smart philosophy, an everyday lifestyle tool for Tourism, Professionals,
                                        Trades and Services. Tourism verticals EAT-SLEEP-SEE-DO industries for local, regional,
                                        interstate, places and venues organising day trips, weekend getaways, annual holidays and
                                        business travel. FindIt Smart Tourism sector 16 Categories of; Accommodation, Activities,
                                        Adventure, Antiques, Attraction, Culture, Dining, Eatery, Entertainment, Landmarks,
                                        Leisure, Recreation, Shopping, Tours, Wellbeing, Wineries, in planning trips, being ideal for
                                        busy people on the go searching directly on smartphones, iPads, laptops or desktops to
                                        optimise experiences.</p>
                                    <p>FindIt Smart Global unique online platform “Easy to find... Simple to use” philosophy can take you
                                        anywhere you choose Travel, Dining, Lifestyle or Adventure, finds a business in 30 seconds
                                        or creates an itinerary in 90 seconds of 30 businesses. Smartphones are the most powerful
                                        tool on the planet 7.51 billion smartphones or 6.04 billion internet users, 74% of the
                                        population use internet with 30% growth by 2029. Tourism industry’s 211 billion dollar
                                        annual turnover, 9.1 million international visitors travel to Australia.</p>
                                    <p>Previously owned Postcards Australia magazine in 2006-2021 had 15 years successful
                                        national brand, spin off from channel nine TV Show Postcards. Smart Discoveries Australia
                                        magazine exposes FindIt Smart business members into major hotel chains and
                                        boutique hotel and motel rooms across Australia. The FindIt Smart network is well-
                                        positioned to capture these markets with having all the regions, shire councils, all towns and
                                        suburbs. FindIt Smart places of interest enable users to find activities of; festivals, events,
                                        cellar doors, spa centres, waterfalls, lookouts, historic landmarks, searchable globally on
                                        FindIt Smart Global all in one platform network.</p>

                            </div>
                            <div class="col-sm-4" id="global-img">
                            </div>
                        </div>
                    </div>
                    <div class="col-sm-1"></div>

                </div>

                <!-- Destination -->
                <div class="row">
                    <div class="col-sm-1"></div>
                    <div class="col-sm-10" id="destination-text">
                        <h2> FIND YOUR NEXT DESTINATION </h2>
                    </div>
                    <div class="col-sm-1"></div>

                </div>
                <div class="row">
                    <div class="col-sm-1"></div>
                    <div class="col-sm-10" id="destinations">
                        <div class="row">
                            <div class="top-content">
                                <div class="container-fluid">
                                    <swiper :slidesPerView="6"
                                            :spaceBetween="10"
                                            :slidesPerGroup="1"
                                            :loop="true"
                                            :loopFillGroupWithBlank="true"
                                            :pagination="false"
                                            :navigation="true"
                                            :breakpoints="swiperOptions.breakpoints"
                                            :modules="modules" id="home-swipe">
                                        <swiper-slide>
                                            <div class="col">
                                                <img :src="storageBaseUrl + '/uploads/VictoriaMonument_VictoriaSquare_4666_1768815016.jpeg'" class="img-fluid mx-auto d-block"
                                                     alt="img1">
                                                <div class="dest-text"><a href="/page/adelaide">Adelaide</a></div>
                                            </div>
                                        </swiper-slide>
                                        <swiper-slide>
                                            <div class="col">
                                                <img :src="storageBaseUrl + '/uploads/Brisbane_City_Skyline_Story_Bridge_4000_1768814832.jpeg'"
                                                     class="img-fluid mx-auto d-block" alt="img2">
                                                <div class="dest-text"><a href="/page/brisbane">Brisbane</a></div>
                                            </div>
                                        </swiper-slide>
                                        <swiper-slide>
                                            <div class="col">
                                                <img :src="storageBaseUrl + '/uploads/Canberra_cropped_6794_1759584032.JPG'"
                                                     class="img-fluid mx-auto d-block" alt="img3">
                                                <div class="dest-text"><a href="/page/canberra">Canberra</a></div>
                                            </div>
                                        </swiper-slide>
                                        <swiper-slide>
                                            <div class="col">
                                                <img :src="storageBaseUrl + '/uploads/NT.ImageGallery_DiscoveringDarwinCity_Waterfront_0800_DNU_1769923716.jpeg'"
                                                     class="img-fluid mx-auto d-block" alt="img4">
                                                <div class="dest-text"><a href="/page/darwin">Darwin</a></div>
                                            </div>
                                        </swiper-slide>
                                        <swiper-slide>
                                            <div class="col">
                                                <img :src="storageBaseUrl + '/uploads/Hobart_7000_1768658825.jpeg'"
                                                     class="img-fluid mx-auto d-block" alt="img4">
                                                <div class="dest-text"><a href="/page/hobart">Hobart</a></div>
                                            </div>
                                        </swiper-slide>
                                        <swiper-slide>
                                            <div class="col">
                                                <img :src="storageBaseUrl + '/uploads/MelbourneCity_1724_1767869748.jpeg'" class="img-fluid mx-auto d-block"
                                                     alt="img4">
                                                <div class="dest-text"><a href="/page/melbourne">Melbourne</a></div>
                                            </div>
                                        </swiper-slide>
                                        <swiper-slide>
                                            <div class="col">
                                                <img :src="storageBaseUrl + '/uploads/equay_1768658487.jpeg'"
                                                     class="img-fluid mx-auto d-block" alt="img4">
                                                <div class="dest-text"><a href="/page/perth">Perth</a></div>
                                            </div>
                                        </swiper-slide>
                                        <swiper-slide>
                                            <div class="col">
                                                <img :src="storageBaseUrl + '/uploads/Discovering_Sydney_City_3462_1768132343.jpeg'"
                                                     class="img-fluid mx-auto d-block" alt="img4">
                                                <div class="dest-text"><a href="/page/sydney">Sydney</a></div>
                                            </div>
                                        </swiper-slide>
                                    </swiper>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>

                <!-- Sectors -->
                <div class="row">
                    <div class="col-sm-1"></div>
                    <div class="col-sm-10" id="destination-text">
                        <h2> SECTORS </h2>
                    </div>
                    <div class="col-sm-1"></div>

                </div>

                <div class="row">
                    <div class="col-sm-1"></div>
                    <div class="col-sm-10" id="sectors" style="text-align:center;">
                        <div class="row">
                            <div class="col-sm-12">
                                <div class="row">
                                    <div class="col-sm-3 col-lg-3 col-xl-3" id="sector1">
                                        <img :src="'/assets/images/Tourism.jpg'">
                                        <div class="top-left">Tourism</div>
                                    </div>
                                    <div class="col-sm-3 col-lg-3 col-xl-3" id="sector2">
                                        <img :src="'/assets/images/Professionals.jpg'">
                                        <div class="top-left">Professionals</div>
                                    </div>
                                    <div class="col-sm-3 col-lg-3 col-xl-3" id="sector3">
                                        <img :src="'/assets/images/Services.jpg'">
                                        <div class="top-left">Services</div>
                                    </div>
                                    <div class="col-sm-3 col-lg-3 col-xl-3" id="sector4">
                                        <img :src="'/assets/images/Trades.jpg'">
                                        <div class="top-left">Trades</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-sm-1"></div>
                </div>

                <!-- Sector Topics -->

                <div class="row" id="sector-topics">
                    <div class="col-sm-1"></div>
                    <div class="col-sm-10" id="destination-text">
                        <h2> SECTOR TOPICS </h2>
                    </div>
                    <div class="col-sm-1"></div>
                    <div class="col-sm-12">
                        <div class="row" id="sector-large">
                            <div class="col-sm-1"></div>
                            <div class="col-sm-10" id="destination-text"
                                 style="border-bottom: 2px solid #dad4d4; margin-bottom: 20px;">
                                <a class="topic-heading active" href="#">Tourism
                                    <div id="line" style="width:60px !important; margin-top:10px !important;"></div>
                                </a>

                                <!--                <a class="topic-heading" href="#">Trades</a>-->
                                <!--                <a class="topic-heading" href="#">Services</a>-->
                                <!--                <a class="topic-heading" href="#">Professionals</a>-->

                            </div>
                            <div class="col-sm-1"></div>

                        </div>
                    </div>

                    <div class="col-sm-12">
                        <div class="row" id="sector-small">
                            <div class="col-sm-12">
                                <div class="row">
                                    <div class="col-sm-1"></div>
                                    <div class="col-sm-10">
                                        <div class="dropdown">
                                            <button class="dropbtn" onclick="myFunction()">Tourism
                                                <i class="fa fa-caret-down"></i>
                                            </button>
                                            <!--                      <div class="dropdown-content" id="myDropdown">-->

                                            <!--                        <a class="topic-heading-small" href="#">Trades</a>-->
                                            <!--                        <a class="topic-heading-small" href="#">Services</a>-->
                                            <!--                        <a class="topic-heading-small" href="#">Professional</a>-->
                                            <!--                      </div>-->
                                        </div>
                                        <br>
                                    </div>
                                    <div class="col-sm-1"></div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- TOURS -->
                <div class="col-sm-12" id="tours">
                    <div class="row">
                        <div class="col-sm-12">
                            <div class="row" id="topics">
                                <div class="col-sm-1"></div>

                                <div class="col-sm-2">
                                    <h3><a href="/page/australian-treasures">Australian Treasures</a></h3>
                                    <p></p>
                                    <br>
                                    <h3><a href="/page/cultural-heritage-trails">Cultural Heritage Trails</a></h3>
                                    <p></p>
                                    <br>
                                    <h3><a href="/page/hiking-trails">Hiking Trails</a></h3>
                                    <p></p>
                                </div>
                                <div class="col-sm-2">
                                    <h3><a href="/page/historic-landmarks">Historic Landmarks</a></h3>
                                    <p></p>
                                    <br>
                                    <h3><a href="/page/lakes">Lakes</a></h3>
                                    <p></p>
                                    <br>
                                    <h3><a href="/page/lookouts">Lookouts</a></h3>
                                    <p></p>
                                </div>
                                <div class="col-sm-2">
                                    <h3><a href="/page/national-parks">National Parks</a></h3>
                                    <p></p>
                                    <br>
                                    <h3><a href="/page/natural-wonders">Natural Wonders</a></h3>
                                    <p></p>
                                    <br>
                                    <h3><a href="/page/rail-trails-cycling-tracks">Rail Trails Cycling Tracks</a></h3>
                                    <p></p>
                                </div>
                                <div class="col-sm-2">
                                    <h3><a href="/page/scenic-drives">Scenic Drives</a></h3>
                                    <p></p>
                                    <br>
                                    <h3><a href="/page/secret-hideaways">Secret Hideaways</a></h3>
                                    <p></p>
                                    <br>
                                    <h3><a href="/page/waterfalls-cascading-wonders">Waterfalls Cascading Wonders</a></h3>
                                    <p></p>
                                </div>
                                <div class="col-sm-2">
                                    <h3><a href="/page/waterways-walking-trails">Waterways Walking Trails</a></h3>
                                    <p></p>
                                    <br>
                                    <h3><a href="/page/wetlands-wonderlands">Wetlands Wonderlands</a></h3>
                                    <p></p>
                                    <br>
                                    <h3><a href="/page/wildlife-experiences">Wildlife Experiences</a></h3>
                                    <p></p>
                                </div>

                                <div class="col-sm-1"></div>
                            </div>
                        </div>
                    </div>
                </div>

                <!--        &lt;!&ndash; TRADES &ndash;&gt;-->
                <!--        <div class="col-sm-12" id="trades">-->
                <!--          <div class="row">-->
                <!--            <div class="col-sm-12">-->
                <!--              <div class="row" id="topics">-->
                <!--                <div class="col-sm-1"></div>-->

                <!--                <div class="col-sm-2">-->
                <!--                  <h3>Topic 1</h3>-->
                <!--                  <p>Description</p>-->
                <!--                  <br>-->
                <!--                  <h3>Topic 2</h3>-->
                <!--                  <p>Description</p>-->
                <!--                  <br>-->
                <!--                  <h3>Topic 3</h3>-->
                <!--                  <p>Description</p>-->
                <!--                </div>-->
                <!--                <div class="col-sm-2">-->
                <!--                  <h3>Topic 1</h3>-->
                <!--                  <p>Description</p>-->
                <!--                  <br>-->
                <!--                  <h3>Topic 2</h3>-->
                <!--                  <p>Description</p>-->
                <!--                  <br>-->
                <!--                  <h3>Topic 3</h3>-->
                <!--                  <p>Description</p>-->
                <!--                </div>-->
                <!--                <div class="col-sm-2">-->
                <!--                  <h3>Topic 1</h3>-->
                <!--                  <p>Description</p>-->
                <!--                  <br>-->
                <!--                  <h3>Topic 2</h3>-->
                <!--                  <p>Description</p>-->
                <!--                  <br>-->
                <!--                  <h3>Topic 3</h3>-->
                <!--                  <p>Description</p>-->
                <!--                </div>-->
                <!--                <div class="col-sm-2">-->
                <!--                  <h3>Topic 1</h3>-->
                <!--                  <p>Description</p>-->
                <!--                  <br>-->
                <!--                  <h3>Topic 2</h3>-->
                <!--                  <p>Description</p>-->
                <!--                  <br>-->
                <!--                  <h3>Topic 3</h3>-->
                <!--                  <p>Description</p>-->
                <!--                </div>-->
                <!--                <div class="col-sm-2">-->
                <!--                  <h3>Topic 1</h3>-->
                <!--                  <p>Description</p>-->
                <!--                  <br>-->
                <!--                  <h3>Topic 2</h3>-->
                <!--                  <p>Description</p>-->
                <!--                  <br>-->
                <!--                  <h3>Topic 3</h3>-->
                <!--                  <p>Description</p>-->
                <!--                </div>-->

                <!--                <div class="col-sm-1"></div>-->
                <!--              </div>-->
                <!--            </div>-->
                <!--          </div>-->
                <!--        </div>-->

                <!--        &lt;!&ndash; SERVICES&ndash;&gt;-->
                <!--        <div class="col-sm-12" id="services">-->
                <!--          <div class="row">-->
                <!--            <div class="col-sm-12">-->
                <!--              <div class="row" id="topics">-->
                <!--                <div class="col-sm-1"></div>-->

                <!--                <div class="col-sm-2">-->
                <!--                  <h3>Topic 1</h3>-->
                <!--                  <p>Description</p>-->
                <!--                  <br>-->
                <!--                  <h3>Topic 2</h3>-->
                <!--                  <p>Description</p>-->
                <!--                  <br>-->
                <!--                  <h3>Topic 3</h3>-->
                <!--                  <p>Description</p>-->
                <!--                </div>-->
                <!--                <div class="col-sm-2">-->
                <!--                  <h3>Topic 1</h3>-->
                <!--                  <p>Description</p>-->
                <!--                  <br>-->
                <!--                  <h3>Topic 2</h3>-->
                <!--                  <p>Description</p>-->
                <!--                  <br>-->
                <!--                  <h3>Topic 3</h3>-->
                <!--                  <p>Description</p>-->
                <!--                </div>-->
                <!--                <div class="col-sm-2">-->
                <!--                  <h3>Topic 1</h3>-->
                <!--                  <p>Description</p>-->
                <!--                  <br>-->
                <!--                  <h3>Topic 2</h3>-->
                <!--                  <p>Description</p>-->
                <!--                  <br>-->
                <!--                  <h3>Topic 3</h3>-->
                <!--                  <p>Description</p>-->
                <!--                </div>-->
                <!--                <div class="col-sm-2">-->
                <!--                  <h3>Topic 1</h3>-->
                <!--                  <p>Description</p>-->
                <!--                  <br>-->
                <!--                  <h3>Topic 2</h3>-->
                <!--                  <p>Description</p>-->
                <!--                  <br>-->
                <!--                  <h3>Topic 3</h3>-->
                <!--                  <p>Description</p>-->
                <!--                </div>-->
                <!--                <div class="col-sm-2">-->
                <!--                  <h3>Topic 1</h3>-->
                <!--                  <p>Description</p>-->
                <!--                  <br>-->
                <!--                  <h3>Topic 2</h3>-->
                <!--                  <p>Description</p>-->
                <!--                  <br>-->
                <!--                  <h3>Topic 3</h3>-->
                <!--                  <p>Description</p>-->
                <!--                </div>-->

                <!--                <div class="col-sm-1"></div>-->
                <!--              </div>-->
                <!--            </div>-->
                <!--          </div>-->
                <!--        </div>-->

                <!--        &lt;!&ndash; PROF &ndash;&gt;-->
                <!--        <div class="col-sm-12" id="prof">-->
                <!--          <div class="row">-->
                <!--            <div class="col-sm-12">-->
                <!--              <div class="row" id="topics">-->
                <!--                <div class="col-sm-1"></div>-->

                <!--                <div class="col-sm-2">-->
                <!--                  <h3>Prof 1</h3>-->
                <!--                  <p>Description</p>-->
                <!--                  <br>-->
                <!--                  <h3>Prof 2</h3>-->
                <!--                  <p>Description</p>-->
                <!--                  <br>-->
                <!--                  <h3>Prof 3</h3>-->
                <!--                  <p>Description</p>-->
                <!--                </div>-->
                <!--                <div class="col-sm-2">-->
                <!--                  <h3>Prof 1</h3>-->
                <!--                  <p>Description</p>-->
                <!--                  <br>-->
                <!--                  <h3>Prof 2</h3>-->
                <!--                  <p>Description</p>-->
                <!--                  <br>-->
                <!--                  <h3>Prof 3</h3>-->
                <!--                  <p>Description</p>-->
                <!--                </div>-->
                <!--                <div class="col-sm-2">-->
                <!--                  <h3>Prof 1</h3>-->
                <!--                  <p>Description</p>-->
                <!--                  <br>-->
                <!--                  <h3>Prof 2</h3>-->
                <!--                  <p>Description</p>-->
                <!--                  <br>-->
                <!--                  <h3>Prof 3</h3>-->
                <!--                  <p>Description</p>-->
                <!--                </div>-->
                <!--                <div class="col-sm-2">-->
                <!--                  <h3>Prof 1</h3>-->
                <!--                  <p>Description</p>-->
                <!--                  <br>-->
                <!--                  <h3>Prof 2</h3>-->
                <!--                  <p>Description</p>-->
                <!--                  <br>-->
                <!--                  <h3>Prof 3</h3>-->
                <!--                  <p>Description</p>-->
                <!--                </div>-->

                <!--                <div class="col-sm-1"></div>-->
                <!--              </div>-->
                <!--            </div>-->
                <!--          </div>-->
                <!--        </div>-->
            </div>

            <fis-footer></fis-footer>
        </div>
    </ion-page>
</template>

<script lang="ts">

import {defineComponent} from 'vue';
import {mapGetters, mapActions} from "vuex";
import homeSearch from "@/components/homeSearch.vue";
import fisHeader from "@/components/fisHeader.vue";
import fisFooter from "@/components/fisFooter.vue";
import sponsorsPage from "@/components/sponsorsPage.vue";
import {IonPage} from "@ionic/vue";
import {Swiper, SwiperSlide} from 'swiper/vue';

import 'swiper/css';
import '@ionic/vue/css/ionic-swiper.css';
import "swiper/css/pagination";
import "swiper/css/navigation";

import {Pagination, Navigation} from "swiper";

export default defineComponent({
    name: 'HomePage',
    components: {Swiper, SwiperSlide, IonPage, fisHeader, fisFooter, homeSearch, sponsorsPage},
    setup() {
        return {
            modules: [Pagination, Navigation],
            swiperOptions: {
                breakpoints: {
                    390: {
                        slidesPerView: 1,
                        spaceBetween: 10
                    },
                    480: {
                        slidesPerView: 2,
                        spaceBetween: 10
                    },
                    1280: {
                        slidesPerView: 4,
                        spaceBetween: 10
                    },
                    1281: {
                        slidesPerView: 6,
                        spaceBetween: 10
                    }

                }
            }
        };
    },
    computed: {
        ...mapGetters({
            getCountries: 'countries/getCountries',
        })
    },
    methods: {
        ...mapActions({
            fetchCountries: 'countries/fetchCountries',
        }),
        async showCountries() {
            await this.fetchCountries();
            this.countries = this.getCountries
        }
    },
    created() {
        this.showCountries();
    },
    data() {
        return {
            storageBaseUrl: `${(process.env.VUE_APP_API_BASE_URL || '').replace(/\/+$/, '')}/storage`,
            countries: {}
        }
    }
});
</script>
